import globalIP from '@/GlobelIP';
import React, { useEffect, useState } from 'react';
import {
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  Container,
  FlexboxGrid,
  Col,
  Button,
  SelectPicker,
  CheckPicker,
  InputGroup,
  Input,
  IconButton,
  Notification
} from 'rsuite';
import img from '../../assets/images/items/noia.jpg';
import { useInView } from 'react-intersection-observer';
import ModalEnquiry from './ModalEnquiry';
import SearchIcon from '@rsuite/icons/Search';
import VisibleIcon from '@rsuite/icons/Visible';
import { Link } from 'react-router-dom';
import { Button as AntdBTN, Modal } from 'antd';
const { confirm } = Modal;
interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}
const EnquiryTracker = () => {
  const [data, setData] = useState([]);
  // useEffect(() => {
  //     data.map((item) => {

  //          console.log(item.id,item.attributes.BuyerNm)
  //     })
  // }, [data])
  const [meta, setMeta] = useState<MetaData>();
  const [limit, setLimit] = useState(0);
  const [open, setOpen] = useState(false);
  const [empid, setEmpId] = useState('');
  const [byernm, setBuyrnm] = useState('');
  const [emcomp, setEmcomp] = useState('');
  const [ememail, setEmemail] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const [selectedBuyer, setSelectedBuyer] = useState([]);
  const [selectedCompny, setSelectedCompny] = useState([]);
  const [selectedArea, setSelectedArea] = useState([]);
  const [selectedGrade, setSelectedGrade] = useState([]);
  const [selectedAgency, setSelectedAgency] = useState([]);
  const [selectedEnquiries, setSelectedEnquiries] = useState<string[]>([]);

  const { ref, inView } = useInView({
    rootMargin: `0px 0px ${700}px 0px`
  });

  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {}, [searchQuery]);

  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState(searchQuery);

  // Debounce effect for searchQuery
  useEffect(() => {
    setCurrentPage(1);
    const timer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 500); // Adjust the debounce delay as needed

    return () => clearTimeout(timer); // Cleanup the timeout if searchQuery changes before the delay
  }, [searchQuery]);

  // Effect that triggers on debouncedSearchQuery
  useEffect(() => {
    // console.log('searchQuery', debouncedSearchQuery);
    setData([]);
    fetchData();
  }, [debouncedSearchQuery]); // This effect now triggers when debouncedSearchQuery changes

  useEffect(() => {
    fetchData();
  }, [currentPage, selectedBuyer, selectedCompny, selectedArea, selectedGrade, selectedAgency]);
  const fetchData = async () => {
    try {
      let buyerFilter = '';
      if (selectedBuyer.length > 0) {
        const buyerFilterString = selectedBuyer
          .map(cat => `filters[BuyerNm][$eq]=${cat}`)
          .join('&');
        buyerFilter = `&${buyerFilterString}`;
      }
      let compnFilter = '';
      if (selectedCompny.length > 0) {
        const compnFilterString = selectedCompny
          .map(cat => `filters[b_cmpnyNm][$eq]=${cat}`)
          .join('&');
        compnFilter = `&${compnFilterString}`;
      }
      let areaFilter = '';
      if (selectedArea.length > 0) {
        const AreaFilterString = selectedArea.map(cat => `filters[area][$eq]=${cat}`).join('&');
        areaFilter = `&${AreaFilterString}`;
      }
      let gradeFilter = '';
      if (selectedArea.length > 0) {
        const gradeFilterString = selectedGrade.map(cat => `filters[grade][$eq]=${cat}`).join('&');
        gradeFilter = `&${gradeFilterString}`;
      }
      let agencyFilter = '';
      if (selectedAgency.length > 0) {
        const agencyFilterString = selectedAgency
          .map(cat => `filters[B_agency][$eq]=${cat}`)
          .join('&');
        agencyFilter = `&${agencyFilterString}`;
      }
      let searchQryFilter = '';
      if (searchQuery.length > 0) {
        let searchQryy = searchQuery.trim();
        const searchQry = `filters[$or][0][BuyerNm][$containsi]=${searchQryy}&filters[$or][1][enqdt][$containsi]=${searchQryy}&filters[$or][2][enqcd][$containsi]=${searchQryy}`;
        // const searchQry = `filters[$or][0][BuyerNm][$containsi]=${searchQryy}&filters[$or][1][enqdt][$containsi]=${searchQryy}`;
        searchQryFilter = `&${searchQry}`;
        //  setCurrentPage(1)
      }
      const response = await fetch(
        `${globalIP}/api/buyqr-enquiries?populate=*&sort[0]=id:desc&filters[isActive][$eq]=true&pagination[page]=${currentPage}${buyerFilter}${compnFilter}${areaFilter}${gradeFilter}${agencyFilter}${searchQryFilter}`
      );
      const json = await response.json();
      setLimit(json.data.length);
      if (currentPage === 1) {
        setData(json.data);
      } else {
        setData(prevData => [...prevData, ...json.data]);
      }

      setMeta(json.meta);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  useEffect(() => {
    if (inView && limit) {
      setCurrentPage(prev => prev + 1);
    }
  }, [inView]);
  const [productdata, setProductData] = useState([]);
  useEffect(() => {
    fetchDataproduct();
  }, []);
  const fetchDataproduct = async () => {
    try {
      const response = await fetch(
        `${globalIP}/api/buyqrenquiry-dets?populate=*&pagination[page]=1`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${globalIP}/api/buyqrenquiry-dets?&pagination[page]=${page}`
        );
        const pageJson = await pageResponse.json();
        allData.push(...pageJson.data);
      }
      setProductData(allData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const getProductCount = enqcd => {
    return productdata.filter(item => item.attributes.enqcd === enqcd).length;
  };
  ///// for Filter /////
  const [buyernmf, setBuyernmf] = useState([]);
  const [compnmf, setCompnmf] = useState([]);
  const [areaf, setAreaf] = useState([]);
  const [gradef, setGradef] = useState([]);
  const [acancyf, setAgancyf] = useState([]);

  useEffect(() => {
    fetchDataf();
  }, []);
  const fetchDataf = async () => {
    try {
      const response = await fetch(`${globalIP}/api/buyqr-enquiries?populate=*&pagination[page]=1`);
      const json = await response.json();
      const allData1 = [];
      const allData2 = [];
      const allData3 = [];
      const allData4 = [];
      const allData5 = [];
      const aarea1 = new Set();
      const aarea2 = new Set();
      const aarea3 = new Set();
      const aarea4 = new Set();
      const aarea5 = new Set();
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${globalIP}/api/buyqr-enquiries?populate=*&pagination[page]=${page}`
        );
        const pageJson = await pageResponse.json();
        const processedData1 = pageJson.data.map(item => {
          if (item.attributes.BuyerNm && item.attributes.isActive === true) {
            const option1 = {
              label: item.attributes.BuyerNm,
              value: item.attributes.BuyerNm
            };
            const op1 = JSON.stringify(option1);
            if (!aarea1.has(op1)) {
              aarea1.add(op1);
            }
          }
        });
        allData1.push(...processedData1);
        const processedData2 = pageJson.data.map(item => {
          if (item.attributes.b_cmpnyNm) {
            const option2 = {
              label: item.attributes.b_cmpnyNm,
              value: item.attributes.b_cmpnyNm
            };
            const op2 = JSON.stringify(option2);
            if (!aarea2.has(op2)) {
              aarea2.add(op2);
            }
          }
        });
        allData2.push(...processedData2);
        const processedData3 = pageJson.data.map(item => {
          if (item.attributes.area) {
            const option3 = {
              label: item.attributes.area,
              value: item.attributes.area
            };
            const op3 = JSON.stringify(option3);
            if (!aarea3.has(op3)) {
              aarea3.add(op3);
            }
          }
        });
        allData3.push(...processedData3);
        const processedData4 = pageJson.data.map(item => {
          if (item.attributes.grade) {
            const option4 = {
              label: item.attributes.grade,
              value: item.attributes.grade
            };
            const op4 = JSON.stringify(option4);
            if (!aarea4.has(op4)) {
              aarea4.add(op4);
            }
          }
        });
        allData4.push(...processedData4);
        const processedData5 = pageJson.data.map(item => {
          if (item.attributes.B_agency) {
            const option5 = {
              label: item.attributes.B_agency,
              value: item.attributes.B_agency
            };
            const op5 = JSON.stringify(option5);
            if (!aarea5.has(op5)) {
              aarea5.add(op5);
            }
          }
        });
        allData5.push(...processedData5);
      }
      const opt1 = Array.from(aarea1).map(tm => JSON.parse(tm));
      const opt2 = Array.from(aarea2).map(tm => JSON.parse(tm));
      const opt3 = Array.from(aarea3).map(tm => JSON.parse(tm));
      const opt4 = Array.from(aarea4).map(tm => JSON.parse(tm));
      const opt5 = Array.from(aarea5).map(tm => JSON.parse(tm));
      setBuyernmf(opt1);
      setCompnmf(opt2);
      setAreaf(opt3);
      setGradef(opt4);
      setAgancyf(opt5);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const handleBuyer = value => {
    setCurrentPage(1); // Reset currentPage when category changes
    setSearchQuery('');
    setSelectedBuyer(value);
  };
  const handleCompny = value => {
    setCurrentPage(1); // Reset currentPage when category changes
    setSearchQuery('');
    setSelectedCompny(value);
  };
  const handleArea = value => {
    setCurrentPage(1); // Reset currentPage when category changes
    setSearchQuery('');
    setSelectedArea(value);
  };
  const handleGrade = value => {
    setCurrentPage(1); // Reset currentPage when category changes
    setSearchQuery('');
    setSelectedGrade(value);
  };
  const handleAgency = value => {
    setCurrentPage(1); // Reset currentPage when category changes
    setSearchQuery('');
    setSelectedAgency(value);
  };
  // const handleSearch = value => {
  //     setSearchQuery(value);
  // }
  // const [searchQryBtn, setSearchQryBtn] = useState(false);

  ////// filter/////
  const [dataGrid, setDataGrid] = useState(6);
  const dataG = [
    { label: 'Medium', value: 6 },
    { label: 'Large', value: 8 },
    { label: 'Extra large', value: 12 }
  ];

  return (
    <>
      <Container className="main">
        <div
          style={{
            justifyContent: 'space-between',
            width: '-webkit-fill-available',
            position: 'fixed',
            height: '180px',
            background: '#fff',
            zIndex: 1
          }}
        >
          <Stack className="table-toolbar" justifyContent="space-between">
            <Stack direction="column" alignItems="flex-start">
              <Stack direction="column" alignItems="flex-start">
                <h3 className="title">Enquiry Tracker</h3>
                <Breadcrumb>
                  <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
                  <Breadcrumb.Item active>Tracker</Breadcrumb.Item>
                </Breadcrumb>
              </Stack>
              <Stack spacing={5}>
                <div id="custom-container" style={{ position: 'relative' }}>
                  <CheckPicker
                    data={buyernmf}
                    placeholder="Select Buyer"
                    value={selectedBuyer}
                    onChange={handleBuyer}
                    style={{ width: 145 }}
                    container={() => document.getElementById('custom-container')}
                  />
                </div>
                <div id="custom-container" style={{ position: 'relative' }}>
                  <CheckPicker
                    data={compnmf}
                    placeholder="Select Company"
                    value={selectedCompny}
                    onChange={handleCompny}
                    style={{ width: 145 }}
                    container={() => document.getElementById('custom-container')}
                  />
                </div>
                <div id="custom-container" style={{ position: 'relative' }}>
                  <CheckPicker
                    data={areaf}
                    placeholder="Select Area"
                    value={selectedArea}
                    onChange={handleArea}
                    style={{ width: 145 }}
                    container={() => document.getElementById('custom-container')}
                  />
                </div>
                <div id="custom-container" style={{ position: 'relative' }}>
                  <CheckPicker
                    data={gradef}
                    placeholder="Select Grade"
                    value={selectedGrade}
                    onChange={handleGrade}
                    style={{ width: 145 }}
                    container={() => document.getElementById('custom-container')}
                  />
                </div>
                <div id="custom-container" style={{ position: 'relative' }}>
                  <CheckPicker
                    data={acancyf}
                    placeholder="Select Agency"
                    value={selectedAgency}
                    onChange={handleAgency}
                    style={{ width: 145 }}
                    container={() => document.getElementById('custom-container')}
                  />
                </div>
              </Stack>
            </Stack>
            <Stack direction="column" alignItems="flex-end" spacing={7}>
              <InputGroup inside>
                {/* <Input
                                placeholder="Search"
                                type="text"
                                value={searchQuery}
                                onChange={value => handleSearch(value)}

                            /> */}
                <Input
                  placeholder="Search"
                  type="text"
                  value={searchQuery}
                  onChange={value => {
                    setSearchQuery(value);
                  }}
                />
                <InputGroup.Addon>
                  <SearchIcon />
                </InputGroup.Addon>
              </InputGroup>
              <SelectPicker
                data={dataG}
                searchable={false}
                style={{ width: 100 }}
                placeholder="Grid"
                onChange={e => setDataGrid(!e ? 6 : e)}
              />
            </Stack>
          </Stack>
          <Divider style={{ marginTop: '5px', marginBottom: '5px' }} />
        </div>
        <div className="row" style={{ marginTop: '168px' }}>
          <Panel>
            {data.length > 0 && (
              <div className="mb-2">
                {(selectedBuyer.length > 0 ||
                  selectedCompny.length > 0 ||
                  selectedArea.length > 0 ||
                  selectedGrade.length > 0 ||
                  // searchQryBtn ||
                  selectedAgency.length > 0) && (
                  <b style={{ marginLeft: '6px' }}>
                    Found Enquiry: {data.length}/{meta.pagination.total}
                  </b>
                )}
                {selectedBuyer.length === 0 &&
                  selectedCompny.length === 0 &&
                  selectedArea.length === 0 &&
                  selectedGrade.length === 0 &&
                  selectedAgency.length === 0 &&
                  meta && (
                    <b style={{ marginLeft: '6px' }}>
                      Enquiries: {data.length}/{meta.pagination.total}
                    </b>
                  )}
              </div>
            )}
            <FlexboxGrid justify="start">
              {data.length === 0 ? (
                <div className="mx-auto">
                  <span style={{ textAlign: 'center', fontSize: '16px', color: '#888' }}>
                    No enquiries available.
                  </span>
                </div>
              ) : (
                data.map(item => {
                  const isSelected = selectedEnquiries.includes(item.id);
                  return (
                    <FlexboxGrid.Item
                      as={Col}
                      colspan={24}
                      md={dataGrid}
                      style={{ marginBottom: '5px' }}
                    >
                      <Panel bordered>
                        <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                          <input
                            type="checkbox"
                            checked={isSelected}
                            style={{ marginRight: '10px', marginTop: '5px' }}
                            onChange={e => {
                              if (e.target.checked) {
                                setSelectedEnquiries(prev => [...prev, item.id]);
                              } else {
                                setSelectedEnquiries(prev => prev.filter(i => i !== item.id));
                              }
                            }}
                          />
                        </div>
                        <Stack justifyContent="space-between">
                          <b>Enquiry No: {item.attributes.enqcd}</b>
                          <IconButton
                            icon={<VisibleIcon />}
                            onClick={() => {
                              setOpen(true);
                              setEmpId(item.attributes.enqcd);
                              setBuyrnm(item.attributes.BuyerNm);
                              setEmcomp(item.attributes.b_cmpnyNm);
                              setEmemail(item.attributes.b_email);
                            }}
                            appearance="primary"
                            color="cyan"
                          />
                        </Stack>
                        <Stack justifyContent="space-between" alignItems="flex-end">
                          <Stack alignItems="flex-start" spacing={10}>
                            {item.attributes?.visitimg_pth?.data?.attributes?.url ? (
                              <img
                                src={`${globalIP}${item.attributes?.visitimg_pth?.data?.attributes?.url}`}
                                style={{ width: '100px', height: '100px' }}
                              />
                            ) : (
                              <img src={img} style={{ width: '100px', height: '100px' }} />
                            )}
                            <Stack direction="column" alignItems="flex-start">
                              <p style={{ fontFamily: 'raleway', fontSize: '14px' }}>
                                {' '}
                                Buyer Name: {item.attributes.BuyerNm}
                              </p>
                              <p style={{ fontFamily: 'raleway', fontSize: '14px' }}>
                                {' '}
                                Date: {new Date(item.attributes.enqdt).toLocaleDateString('en-GB')}
                              </p>
                              <p style={{ fontFamily: 'raleway', fontSize: '14px' }}>
                                {' '}
                                No. of products: {getProductCount(item.attributes.enqcd)}
                              </p>
                              <p style={{ fontFamily: 'raleway', fontSize: '14px' }}>
                                {' '}
                                Mobile No: {item.attributes.mobileNo}
                              </p>
                              <p
                                style={{
                                  fontFamily: 'raleway',
                                  fontSize: '14px',
                                  whiteSpace: 'nowrap'
                                }}
                              >
                                {' '}
                                Email: {item.attributes.b_email}
                              </p>
                            </Stack>
                          </Stack>
                        </Stack>
                      </Panel>
                    </FlexboxGrid.Item>
                  );
                })
              )}
            </FlexboxGrid>
          </Panel>
          <Button ref={ref} style={{ visibility: 'hidden' }}></Button>
          {selectedEnquiries.length > 0 && (
            <Notification
              type="success"
              onClose={() => setSelectedEnquiries([])} // optional close button
              style={{
                position: 'fixed',
                top: '80%',
                right: 20,
                transform: 'translateY(-50%)',
                zIndex: 9999,
                background: '#0070a9',
                color: 'white'
                // width: '20%'
              }}
              duration={0}
              className="view"
              closable
            >
              <b style={{ color: 'white' }}>Selected Enquiries: {selectedEnquiries.length}</b>
              <Divider style={{ borderColor: 'rgba(255,255,255,0.3)' }} />
              <Stack spacing={8}>
                <AntdBTN
                  type="primary"
                  danger
                  onClick={() => {
                    confirm({
                      title: 'Are you sure you want to inactivate the selected enquiries?',
                      content: `This will inactivate ${selectedEnquiries.length} selected enquiries.`,
                      okText: 'Yes',
                      okType: 'danger',
                      cancelText: 'No',
                      onOk: async () => {
                        try {
                          await Promise.all(
                            selectedEnquiries.map(id =>
                              fetch(`${globalIP}/api/buyqr-enquiries/${id}`, {
                                method: 'PUT',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ data: { isActive: false } })
                              })
                            )
                          );
                          setSelectedEnquiries([]);
                          setCurrentPage(1); // optional: reset pagination
                          fetchData(); // refresh active items
                        } catch (err) {
                          console.error(err);
                        }
                      },
                      onCancel() {
                        console.log('Cancelled');
                      }
                    });
                  }}
                >
                  Inactivate
                </AntdBTN>

                {/* <Link
                                    to={{
                                        pathname: `/${ugr}/editDetails`,
                                        search: `?selectedEnquiries=${selectedEnquiries.join(',')}`
                                    }}
                                >
                                    <Button appearance="primary" color="green">
                                        View
                                    </Button>
                                </Link> */}
              </Stack>
            </Notification>
          )}
        </div>
        <Stack
          className="copyright"
          justifyContent="flex-end"
          spacing={5}
          style={{
            position: 'fixed',
            bottom: '0',
            width: '-webkit-fill-available',
            textAlign: 'center',
            backgroundColor: 'white',
            paddingRight: '16px'
          }}
        >
          <p>© All Right Reserved. Product by </p>
          <p>
            {' '}
            <a href="https://erpdaddy.com/" target="_blank">
              ERP Daddy Softwere Solution.
            </a>
          </p>
        </Stack>
      </Container>
      {open && (
        <ModalEnquiry
          open={open}
          onClose={() => setOpen(false)}
          empid={empid}
          byernm={byernm}
          emcomp={emcomp}
          ememail={ememail}
        />
      )}
    </>
  );
};

export default EnquiryTracker;
